export const TAN_BG = '#efece6';
export const DARK_BLUE_BG = '#1e2939';

export const BIDET_TIERS = ['Basic', 'Mid-Range', 'High-End'];
